import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import authentication from './auth/msalClient';

const Context = React.createContext();
authentication.initialize();

authentication.run(() => {
  ReactDOM.render(
    <Context.Provider value={authentication}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Context.Provider>,
    document.getElementById('root')
  );
  serviceWorker.unregister();
});
//ReactDOM.render(app, document.getElementById("root"));
